import makeSlice from '@web/slices/reward/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {products} = payload

            state.products = products.map((product) => {
                return {
                    itemId: product.items[0]?.orderSheetItemId ?? '',
                    imageUrl: product.productImageUrl,
                    name: product.productName,
                }
            })
        })
    },
})

export default slice.reducer

export const actions = slice.actions
